import React, { useEffect } from 'react';
import { CreateAccount } from "./components/CreateAccount";
import { ActivateAccount } from "./components/ActivateAccount";
import { ResetPassword } from "./components/ResetPassword";
import { Landing } from "./components/Landing";

// Redirect component that uses env var REACT_APP_LOGIN_URL
const LoginRedirect = () => {
  useEffect(() => {
    const attempt = () => {
      const cfg = window.__FRONTEND_CONFIG;
      const target = cfg && cfg.loginUrl ? cfg.loginUrl : null;
      if (target) {
        window.location.replace(target);
      } else {
        // retry shortly until config loaded
        setTimeout(attempt, 100);
      }
    };
    attempt();
  }, []);
  return null;
};

const AppRoutes = [
  {
    index: true,
    element: <Landing />
  },
  {
    path: '/create_account',
    element: <CreateAccount />
  },
  {
    path: '/activate_account',
    element: <ActivateAccount />
  },
  {
    path: '/reset_password',
    element: <ResetPassword />
  },
  // New login redirect route
  {
    path: '/login',
    element: <LoginRedirect />
  }
];

export default AppRoutes;